import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { RegexFields } from '../../../constants/utils/regexFields';
import * as Loadings from '../../../constants/loadings/auth';

export const IdentityInit = () => {
	const history = useHistory();
	const numberFormRef = useRef(null);
	const auth = useSelector(state => state.auth);
	const [phoneNumber, setPhoneNumber] = useState('');

	function formSubmit(event) {
		event.preventDefault();
		if (numberFormRef.current.checkValidity()) {
			//dispatch(sendCode());
			history.push("/auth/identity/code");
		}
		numberFormRef.current.classList.add('was-validated');
	}

	return (
		<div className="col order-first order-lg-last h-inherit scroll-default">
			<nav className="nav text-right mb-auto">
				<h1 className="sr-only visually-hidden">Register</h1>
				<span className="small font-weight-bold ml-auto">Je n'ai pas de compte ? <Link className="text-primary" to="/auth/signup/">S'inscrire</Link></span>
			</nav>
			<form className="container-xl-base py-2 mb-auto" noValidate ref={numberFormRef} onSubmit={(event) => { formSubmit(event); }}>
				<h1 className="h1 text-primary font-weight-bolder">Confirmation d’identité.</h1>
				<p className="o-50 mb-4 small" >Veuillez mettre votre numéro de téléphone pour recevoir par message un code</p>
				<div className="form-group mb-lg-6">
					<label className="h6 font-weight-bolder" htmlFor="phone">Votre numéro de téléphone</label>
					<input type="text" required className="form-control" id="phone" value={phoneNumber} placeholder="00 00 00 00 00" pattern={RegexFields.frenchPhoneNumber}
						onInput={(event) => {
							event.preventDefault();
							if (event.target.value.match(/^[+\d ]*$/) !== null || event.target.value === '') {
								if (!event.target.value.endsWith(' ')) {
									setPhoneNumber(event.target.value.replace(/\s/g, '').trim());
								}
								else {
									setPhoneNumber(event.target.value);
								}
							}
						}} onBlur={() => {
							setPhoneNumber(phoneNumber.trim());
						}} />
					<div className="invalid-feedback">Wrong number</div>
				</div>
			</form>
			<footer className="block mt-auto text-left w-100 rounded-inherit">
				<Link to="/auth/signin" className="btn btn-faded px-md-gutter mr-3">Fermer</Link>
				<button className={"btn btn-info px-md-gutter px-4 loading-btn" + (auth.isLoading.includes(Loadings.SEND_PHONE_NUMBER) ? ' show' : '')} disabled={auth.isLoading.includes(Loadings.SEND_PHONE_NUMBER)}
					onClick={(event) => { formSubmit(event); }}>Suivant <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
			</footer>
		</div>
	);
};